import { SubAPI } from "./SubAPI";
export class ProductCatalogs extends SubAPI {
    list(props) { return this.fetcher.get("/api/product-catalogs", props); }
    upsert(input) { return this.fetcher.post("/api/product-catalog", input); }
    upload(input) { return this.fetcher.postFormData("/api/product-catalog/upload", { file: input.file, meta: JSON.stringify({ manufacturer: input.manufacturer, categories: input.categories }) }); }
    fileLink(id) { let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "attachment"; return "/api/product-catalog/file?id=" + id + "&type=" + type; }
}
